import React, { useState, useEffect, useContext } from "react";
import { TransportOwnerContext } from "./TransportOwnerContext";
import Pagination from "../../Pagination";
import "./transOwner.css"
import Spinner from "../../Spinner"
export default function TransOwnerDash() {

function handleDeleteClick(transporterName){
  formik.setFieldValue("name",transporterName)
  setRelToDelete(true)
}


  const {formik, availableTransporters, setRelToDelete, newTransporterData, postsPerPage, currentPage, paginate, ownerTransporters,fetchingTrans } = useContext(TransportOwnerContext);
  const shouldPaginate = ownerTransporters.length > 4
  const displayedTranspoerters = shouldPaginate ? newTransporterData : ownerTransporters
  
  return (
    <div className="bg-gray-100 mt-2  mb-16">
      {/* {data.length > 0 ? ( */}
        <div className="mt-2">
        <h3 className="text-blue-500">Transporters:</h3>
        {displayedTranspoerters.length > 0 ?
          <div className="transporter-grid max-w-full min-w-fit mt-2 mb-6">
            {displayedTranspoerters.map((transporter, index) => (
                <div key={index} className="transporter-card ">
                      <form onSubmit={formik.handleSubmit} className=" ">
                        <button className=" flex flex-initial bg-red-500 rounded-lg disabled:opacity-50 h-4 w-10 text-xs" onClick={()=>handleDeleteClick(transporter.name)} disabled={formik.isSubmitting } type="submit"> 
                          DELETE
                        </button>
                      </form>
                    <div className="transporter-container" key={index}>
                      <img src={transporter.image_url} alt={transporter.name} className="transporter-image"
                        onError={(e) => e.target.style.display = 'none'} />
                          <div className="data-overlay" key={index}> 
                            <p className="text-white italic">{transporter.name}</p>
                            <p className="text-white italic">{transporter.email}</p>
                            <h4 className="text-white italic">{transporter.location}</h4>
                          </div>
                                      
                  </div>
                </div>
            ))}
          </div>
           :
          <div>
            {fetchingTrans?<Spinner/>:<p>Sorry you do not have nat transporter,want to add </p>}
          </div>}
        {shouldPaginate ? <Pagination postsPerPage={postsPerPage} totalPosts={ownerTransporters.length} currentPage={currentPage} paginate={paginate} /> : null}
        {availableTransporters.length > 0 ?
        <div>
          <form onSubmit={formik.handleSubmit}>
            <select
              value={formik.values.name}
              onChange={formik.handleChange}
              className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
              name="name"
            >
              <option value="">Select a transporter to add</option>
              {availableTransporters.map((transporter, index) => (
                <option value={transporter.name} key={index}>{transporter.name}</option>
              ))}
            </select>
            <button
              type="submit"
              className="bg-blue-500 rounded-lg text-white disabled:opacity-50"
              disabled={formik.isSubmitting || !formik.isValid}
              onClick={(e) => { setRelToDelete(false) }}
            >
              Send request
            </button>
          </form>
        </div>:null
          
        }
      </div>
      
    </div>
  );
}



